import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { UPLOADS, SOCIALS, DIAGNOSTIC_URL } from '../lib/site';
import { Reveal } from './Reveal';
const WORDS = ['Lead Generation', 'Lead Response', 'Facebook Ads'];
function useTypewriter(words: string[]) {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState('');
  const [deleting, setDeleting] = useState(false);
  useEffect(() => {
    const current = words[index];
    let delay = deleting ? 55 : 110;
    if (!deleting && text === current) delay = 1600;else if (deleting && text === '') delay = 300;
    const t = setTimeout(() => {
      if (!deleting && text === current) setDeleting(true);else if (deleting && text === '') {
        setDeleting(false);
        setIndex(i => (i + 1) % words.length);
      } else setText(p => deleting ? current.slice(0, p.length - 1) : current.slice(0, p.length + 1));
    }, delay);
    return () => clearTimeout(t);
  }, [text, deleting, index, words]);
  return text;
}
export function Hero() {
  const word = useTypewriter(WORDS);
  return <section id="home" className="relative flex min-h-[calc(100vh-7rem)] w-full items-center overflow-hidden" data-id="element-134" data-mp="3o6kg9kdpcg66">
      <img src={UPLOADS + 'teamwork-studioweb-vip.jpg'} alt="Studio Web VIP team working on lead response systems" className="absolute inset-0 h-full w-full object-cover" data-id="element-135" data-mp="399jojgvigl7p" />
      <div className="absolute inset-0 bg-black/60" data-id="element-136" data-mp="30hhsdush5r38" />
      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 py-24 lg:px-8" data-id="element-137" data-mp="30fy7trzsctvn">
        <div className="flex flex-col items-center text-center" data-id="element-138" data-mp="35aasu6gwud9i">
          <Reveal anim="slideInLeft" data-id="element-139" data-mp="2qkmthasahoof">
            <div className="mb-6 flex items-center gap-4" data-id="element-140" data-mp="2qloeo830rrjv">
              <span className="text-[14px] font-bold uppercase tracking-[0.3em] text-[#FFB700]" data-id="element-141" data-mp="2vi55ja1lsk0n">Paid Acquisition Systems for Service Businesses</span>
              <span className="hidden h-px w-24 bg-[#FFB700] sm:block sm:w-40" data-id="element-142" data-mp="2hl9qn0yo7yco" />
            </div>
          </Reveal>
          <h1 className="font-heading uppercase leading-[1]" data-id="element-143" data-mp="s21gc6a6u3xc">
            <span className="block whitespace-nowrap text-[9.5vw] text-black lg:text-[100px]" data-id="element-144" data-mp="s3mb9x0ezovq">A creative digital</span>
            <span className="block min-h-[1em] whitespace-nowrap text-[9.5vw] text-[#00CEA6] lg:text-[100px]" data-id="element-145" data-mp="n98dxp26z7of">
              {word}<span className="text-white" data-id="element-146" data-mp="dd5eiqyq5n56">.</span>
              <motion.span aria-hidden animate={{
              opacity: [1, 0]
            }} transition={{
              repeat: Infinity,
              duration: 0.9
            }} className="ml-1 inline-block text-[#00CEA6]" data-id="element-147" data-mp="degiorw30wwt">|</motion.span>
            </span>
          </h1>
          <Reveal anim="slideInUp" className="mt-10 max-w-3xl" data-id="element-148" data-mp="162cd1py6icqf">
            <p className="text-base leading-relaxed text-white sm:text-lg" data-id="element-149" data-mp="111yauoj9dx0b">
              Every new lead gets an answer in seconds, your team gets alerted, and every Monday you see which leads were worked and which were lost. <span className="text-[#FFB700]" data-id="element-150" data-mp="3lu07neppzt62">The system is automated. The judgment isn’t.</span>
            </p>
          </Reveal>
          <Reveal anim="slideInLeft" className="mt-10 flex flex-col items-center gap-4 sm:flex-row" data-id="element-151" data-mp="3htg8y6pi0hht">
            <a href={DIAGNOSTIC_URL} className="group inline-flex items-center gap-3 rounded-full bg-[#FFB700] px-9 py-4 text-sm font-bold uppercase tracking-wider text-black transition-transform hover:scale-[1.03]" data-id="element-152" data-mp="1x7853o1s1ru4">
              Book Free Diagnostic
              <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-153" data-mp="2b0zhr5at1ru2" />
            </a>
            <a href="#services" className="rounded-full border-2 border-white/40 px-8 py-3.5 text-sm font-bold uppercase tracking-wider text-white hover:border-[#FFB700] hover:text-[#FFB700]" data-id="element-154" data-mp="2fz0vrbtdj0yo">How It Works</a>
          </Reveal>
        </div>
      </div>
      <div className="absolute bottom-8 right-5 z-10 flex flex-wrap justify-end gap-x-4 gap-y-2 text-[13px] text-[#FFB700] sm:gap-x-6 sm:text-sm lg:right-8" data-id="element-155" data-mp="2tzley937aysp">
        {SOCIALS.map(s => <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white" data-id="element-156" data-mp="uokebphu3v7b">{s.label}</a>)}
      </div>
    </section>;
}